var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('div',{staticClass:"nav-wrapper"},[_c('navbar')],1),_c('div',{staticClass:"main-container"},[_c('router-view')],1),_c('div',{staticClass:"footer-wrapper"},[_c('app-footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }